import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/machine/pointsGraphics/filter'; // Importing Filter component
import PointsList from 'views/machine/pointsGraphics/pointsList'; // Importing PointsList component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the points graphics view.
 * @extends JetView
 */
export default class pointsGraphicsView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        const left = {
            Width: 250, // Width of the left panel
            responsiveCell: false, // Disable responsive cell behavior
            rows: [
                {
                    view: 'toolbar', // Toolbar component
                    css: theme, // Apply theme to the toolbar
                    elements: [
                        { view: 'label', label: _('Máquinas Grafica') }, // Label with localized text
                        {
                            type: 'wide', // Wide type for the button
                            css: 'close-bottom', // CSS class for styling
                            cols: [
                                {
                                    view: 'icon', // Icon component
                                    icon: 'wxi-close', // Close icon
                                    bottom: 20, // Bottom margin
                                    right: 35, // Right margin
                                    width: 30, // Icon width
                                    height: 30, // Icon height
                                    click: () => this.show('/top/dashboard'), // Click event to navigate to dashboard
                                },
                            ],
                        },
                    ],
                },
                Filter, // Filter component added to the layout
                PointsList, // PointsList component added to the layout
            ],
        };

        webix.ui.fullScreen(); // Enable full screen mode for the UI

        return {
            id: 'a5', // Unique identifier for the view
            type: 'clean', // Clean type for the form
            view: 'form', // Form view
            scroll: 'y', // Enable vertical scrolling
            rows: [
                {
                    responsive: 'a5', // Responsive behavior for the row
                    type: 'wide', // Wide type for the row
                    css: 'out', // CSS class for styling
                    cols: [left], // Left panel configuration
                },
            ],
        };
    }
}

// FILE DOCUMENTED
